import Box from '@mui/joy/Box'
import Card from '@mui/joy/Card'
import CardActions from '@mui/joy/CardActions'
import CardContent from '@mui/joy/CardContent'
import Divider from '@mui/joy/Divider'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Input from '@mui/joy/Input'
import Typography from '@mui/joy/Typography'
import { CircularProgress } from '@mui/material'
import Button from '@mui/joy/Button'
import Person from '@mui/icons-material/Person'
import { useUser } from '@clerk/clerk-react'
import { useState } from 'react'
import { Loading } from './ui/Loading'

export const ClerkUserInfo = ({ onSubmit }) => {
    const { user, isLoaded } = useUser()

    const [formValuesChanged, setFormValuesChanged] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = new FormData(e.currentTarget)
        const firstName = data.get('firstName')
        const lastName = data.get('lastName')

        try {
            setLoading(true)
            await user.update({ firstName, lastName })
            onSubmit({ firstName, lastName })
            setFormValuesChanged(false)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e) => {
        e.preventDefault()
        setFormValuesChanged(true)
    }

    if (!isLoaded) {
        return <Loading />
    }

    return (
        <Card
            variant="outlined"
            sx={{
                maxHeight: 'max-content',
                maxWidth: '100%',
                width: '50%',
                overflow: 'auto',
            }}
        >
            <Typography level="title-lg" startDecorator={<Person />}>
                User Info
            </Typography>
            <Divider inset="none" />
            <form onSubmit={handleSubmit}>
                <CardContent
                    sx={{
                        gap: 1.5,
                    }}
                >
                    <FormControl sx={{ gridColumn: '1/-1' }}>
                        <FormLabel>First Name</FormLabel>
                        <Input
                            name="firstName"
                            defaultValue={user.firstName}
                            onChange={handleChange}
                        />
                    </FormControl>
                    <FormControl sx={{ gridColumn: '1/-1' }}>
                        <FormLabel>Last Name</FormLabel>
                        <Input
                            name="lastName"
                            defaultValue={user.lastName}
                            onChange={handleChange}
                        />
                    </FormControl>
                    <FormControl sx={{ gridColumn: '1/-1' }}>
                        <FormLabel>Email Address</FormLabel>
                        <Input
                            defaultValue={user.primaryEmailAddress.emailAddress}
                            onChange={handleChange}
                        />
                    </FormControl>
                    <CardActions>
                        <Box
                            sx={{
                                flex: 1,
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <Button
                                variant="solid"
                                color="primary"
                                type="submit"
                                disabled={loading || !formValuesChanged}
                                sx={{ minWidth: '81px' }}
                            >
                                {loading ? (
                                    <CircularProgress size="1rem" />
                                ) : (
                                    'Update'
                                )}
                            </Button>
                        </Box>
                    </CardActions>
                </CardContent>
            </form>
        </Card>
    )
}
